import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Script from 'next/script';
import '../styles/globals.css';
import { ConsentManager, updateGTMConsent, hasUserMadeChoice, getAllConsents } from '../utils/ConsentUtils';
import OneTapLogin from '../components/OneTapLogin';

// ID GTM
const GTM_ID = 'GTM-KC5G5WLD'; // Убедитесь, что это ваш корректный ID

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  
  // Проверка наличия принудительного выхода
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const forceLogout = localStorage.getItem('force_logout') === 'true';
      const logoutParam = router.query.logout === 'true';
      
      if (forceLogout || logoutParam) {
        localStorage.removeItem('force_logout');
        
        try {
          localStorage.removeItem('auth_action');
          localStorage.removeItem('user-storage');
          sessionStorage.removeItem('backend_verified');
          
          const cookiesToClear = ['jwt_access_token', 'jwt_refresh_token', 'auth_token', 'firebase_token'];
          cookiesToClear.forEach(name => {
            document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
          });
        } catch (e) {
          console.error('Error clearing auth data:', e);
        }
      }
    }
  }, [router.query]);
  
  // Применение сохраненных настроек согласия
  // Этот useEffect вызывается после монтирования MyApp
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag && hasUserMadeChoice()) {
      const savedConsent = getAllConsents();
      // Обновляем состояние согласия GTM на основе ранее сохраненного выбора.
      // Это должно произойти после 'consent default' и достаточно быстро,
      // чтобы GTM учел это благодаря 'wait_for_update'.
      updateGTMConsent(savedConsent.analytics, savedConsent.advertising);
    }
  }, []); // Пустой массив зависимостей, чтобы выполнился один раз после монтирования

  return (
    <>
      <Head>
        <title>My App</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      
      {/* Инициализация dataLayer и УСТАНОВКА СОГЛАСИЯ ПО УМОЛЧАНИЮ */}
      {/* Этот скрипт должен выполниться ДО загрузки GTM */}
      <Script
        id="gtm-consent-init"
        strategy="beforeInteractive" // Очень важно для установки default consent
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            window.gtag = gtag; // Делаем gtag доступным глобально как можно раньше
            
            // Устанавливаем значения по умолчанию для всех типов согласия
            // Это должно произойти перед загрузкой GTM
            gtag('consent', 'default', {
              'ad_storage': 'denied',
              'ad_user_data': 'denied',
              'ad_personalization': 'denied',
              'analytics_storage': 'denied',
              'personalization_storage': 'denied', // Добавлено или если уже было, то хорошо
              'functionality_storage': 'granted', // Обычно всегда разрешены
              'security_storage': 'granted',     // Обычно всегда разрешены
              'wait_for_update': 500             // GTM будет ждать до 500мс обновления согласия
            });
          `
        }}
      />
      
      {/* Загрузка Google Tag Manager */}
      {/* Этот скрипт загружает сам GTM */}
      <Script
        id="gtm-script"
        strategy="afterInteractive" // Загружаем GTM после интерактивности страницы
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GTM_ID}');
          `
        }}
      />
      
      <Component {...pageProps} />
      
      <OneTapLogin />
      
      <noscript>
        <iframe 
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0" 
          width="0" 
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
      
      <ConsentManager />
    </>
  );
} 

export default MyApp;